export { default } from './StaticPageSection';
